export function TooltipPlacement() {
  return (
    <>
      <div className="mb-3 flex gap-3">
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-top"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Top`}
        </button>
        <div
          data-tooltip="tooltip-top"
          data-tooltip-placement="top"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-top-start"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Top Start`}
        </button>
        <div
          data-tooltip="tooltip-top-start"
          data-tooltip-placement="top-start"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-top-end"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Top End`}
        </button>
        <div
          data-tooltip="tooltip-top-end"
          data-tooltip-placement="top-end"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
      </div>
      <div className="mb-3 flex gap-3">
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-right"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Right`}
        </button>
        <div
          data-tooltip="tooltip-right"
          data-tooltip-placement="right"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-right-start"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Right Start`}
        </button>
        <div
          data-tooltip="tooltip-right-start"
          data-tooltip-placement="right-start"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-right-end"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Right End`}
        </button>
        <div
          data-tooltip="tooltip-right-end"
          data-tooltip-placement="right-end"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
      </div>
      <div className="mb-3 flex gap-3">
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-bottom"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Bottom`}
        </button>
        <div
          data-tooltip="tooltip-bottom"
          data-tooltip-placement="bottom"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-bottom-start"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Bottom Start`}
        </button>
        <div
          data-tooltip="tooltip-bottom-start"
          data-tooltip-placement="bottom-start"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-bottom-end"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Bottom End`}
        </button>
        <div
          data-tooltip="tooltip-bottom-end"
          data-tooltip-placement="bottom-end"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
      </div>
      <div className="mb-3 flex gap-3">
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-left"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Left`}
        </button>
        <div
          data-tooltip="tooltip-left"
          data-tooltip-placement="left"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-left-start"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Left Start`}
        </button>
        <div
          data-tooltip="tooltip-left-start"
          data-tooltip-placement="left-start"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
        <button
          data-ripple-light="true"
          data-tooltip-target="tooltip-left-end"
          className="select-none rounded-lg bg-gray-900 py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        >
          {`Left End`}
        </button>
        <div
          data-tooltip="tooltip-left-end"
          data-tooltip-placement="left-end"
          className="absolute z-50 whitespace-normal break-words rounded-lg bg-black py-1.5 px-3 font-sans text-sm font-normal text-white focus:outline-none"
        >
          {`Material Tailwind`}
        </div>
      </div>
    </>
  );
}
